@if (myself) {
  <section class="user-settings-consents-wrapper" [attr.aria-labelledby]="'consents-heading'">
    <app-cr-header id="consents-heading" [headingLevel]="2">
      {{ 'USER_SETTINGS.USER_SETTINGS_CONSENTS' | translate }}
    </app-cr-header>
    @if (tableConsents; as data) {
      <nz-table class="user-settings-consents-table" [nzData]="tableConsents" [nzHideOnSinglePage]="true">
        <caption class="sr-only">
          {{
            'USER_SETTINGS.USER_SETTINGS_CONSENTS_TABLE_CAPTION' | translate
          }}
        </caption>
        <thead>
          <tr>
            <th scope="col" class="name-cell header">{{ 'USER_SETTINGS.CONSENTS.LABELS.NAME' | translate }}</th>
            <th scope="col" class="source-cell header">{{ 'USER_SETTINGS.CONSENTS.LABELS.SOURCE' | translate }}</th>
            <th scope="col" class="status-cell header">{{ 'USER_SETTINGS.CONSENTS.LABELS.STATUS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (item of data; track item) {
            <tr>
              <td class="name-cell value">{{ item.label }}</td>
              <td class="source-cell value">
                @if (item.urlHtml) {
                  <span [innerHTML]="item.urlHtml"></span>
                }
                @if (!item.urlHtml) {
                  <span>-</span>
                }
              </td>
              <td
                class="status-cell value"
                [attr.aria-label]="
                  item.acceptedAt
                    ? ('USER_SETTINGS.USER_SETTINGS_CONSENTS_GRANTED' | translate)
                    : ('USER_SETTINGS.USER_SETTINGS_CONSENTS_NOT_GRANTED' | translate)
                ">
                @if (item.acceptedAt) {
                  @if (deviceInfo.deviceTypeDetected === 'DESKTOP') {
                    <mat-icon class="granted" [attr.aria-hidden]="true"> check </mat-icon>
                  }
                  <span>
                    {{ 'USER_SETTINGS.CONSENTS.CONSENT_GRANTED' | translate }}:
                    <b>{{ item.acceptedAt | date: 'dd.MM.yyyy HH:mm' }}</b>
                  </span>
                }
                @if (!item.acceptedAt) {
                  @if (deviceInfo.deviceTypeDetected === 'DESKTOP') {
                    <mat-icon class="not-granted" [attr.aria-hidden]="true"> close </mat-icon>
                  }
                  <span>{{ 'USER_SETTINGS.CONSENTS.CONSENT_NOT_GRANTED' | translate }}</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    }
    @if (!tableConsents) {
      <div class="loading-wrapper" role="status" aria-live="polite">
        <mat-spinner [diameter]="50" [attr.aria-hidden]="true"></mat-spinner>
        <div class="spinner-message">
          {{ 'USER_SETTINGS.LOADING_CONSENTS' | translate }}
        </div>
      </div>
    }
  </section>
}
